import { render } from "./SelectAnnotationSet.vue?vue&type=template&id=f3a2506e"
import script from "./SelectAnnotationSet.vue?vue&type=script&lang=js"
export * from "./SelectAnnotationSet.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__